import React from 'react';
import { Mail, Clock, MessageCircle } from 'lucide-react';
import { LegalLayout } from './LegalLayout';
export const Contact = () => {
  return <LegalLayout title="Contacto" data-id="element-338">
      <p className="text-lg text-gray-300 leading-relaxed mb-8 font-sans" data-id="element-339">
        ¿Tienes una pregunta sobre el plan, problemas con tu descarga, o
        necesitas solicitar un reembolso? Estoy aquí para ayudarte.
      </p>

      {/* Email card */}
      <div className="bg-[#0a0a0a] border-2 border-[#ADFF2F]/30 rounded-xl p-6 md:p-8 mb-8" data-id="element-340">
        <div className="flex items-start gap-4" data-id="element-341">
          <div className="shrink-0 w-12 h-12 rounded-full bg-[#ADFF2F] flex items-center justify-center" data-id="element-342">
            <Mail className="w-6 h-6 text-black" data-id="element-343" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-344">
            <p className="text-sm text-gray-400 uppercase tracking-wider font-semibold mb-1 font-sans" data-id="element-345">
              Email de contacto
            </p>
            <a href="mailto:edison_link@hotmail.com" className="text-xl md:text-2xl text-[#ADFF2F] font-bold hover:underline break-all font-sans" data-id="element-346">
              edison_link@hotmail.com
            </a>
          </div>
        </div>
      </div>

      {/* Info cards */}
      <div className="grid sm:grid-cols-2 gap-4 mb-8" data-id="element-347">
        <div className="bg-[#0a0a0a] border border-white/10 rounded-xl p-5" data-id="element-348">
          <Clock className="w-6 h-6 text-[#ADFF2F] mb-3" data-id="element-349" />
          <h3 className="text-white font-bold mb-1 font-sans" data-id="element-350">
            Tiempo de respuesta
          </h3>
          <p className="text-gray-400 text-sm font-sans m-0" data-id="element-351">
            Respondemos en menos de 24 horas hábiles.
          </p>
        </div>

        <div className="bg-[#0a0a0a] border border-white/10 rounded-xl p-5" data-id="element-352">
          <MessageCircle className="w-6 h-6 text-[#ADFF2F] mb-3" data-id="element-353" />
          <h3 className="text-white font-bold mb-1 font-sans" data-id="element-354">
            Para qué escribir
          </h3>
          <p className="text-gray-400 text-sm font-sans m-0" data-id="element-355">
            Soporte, dudas del plan, reembolsos o sugerencias.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10 pt-6" data-id="element-356">
        <h3 className="text-xl font-bold text-white mb-3 font-sans" data-id="element-357">
          Antes de escribir
        </h3>
        <p className="text-gray-400 leading-relaxed font-sans" data-id="element-358">
          Revisa la sección de{' '}
          <a href="/#faq" className="text-[#ADFF2F] hover:underline" data-id="element-359">
            preguntas frecuentes
          </a>{' '}
          en la página principal — es posible que tu duda ya esté respondida
          ahí.
        </p>
      </div>
    </LegalLayout>;
};